<template>
  <div>
    <template v-if="event">
      <b style="word-break: break-word"
        ><router-link
          :to="{
            name: eventPage,
            params: { eventId: event.id },
            state: additionalParams ?? {}
          }"
          class="no-default-link-style"
          >{{ event.name }}</router-link
        ></b
      >
      <div class="text-muted">
        <router-link
          :to="{
            name: 'OrganisationProfilePage',
            params: { organisationId: event.organiser.id }
          }"
          class="no-default-link-style"
        >
          {{ event.organiser.name }} </router-link
        ><template v-if="event.hostOrganisation">
          |
          <router-link
            :to="{
              name: 'OrganisationProfilePage',
              params: { organisationId: event.hostOrganisation.id }
            }"
            class="no-default-link-style"
          >
            {{ event.hostOrganisation.name }}
          </router-link>
        </template>
      </div>
    </template>
    <template v-else> Missing event! </template>
  </div>
</template>
<script>
import gql from "fraql";
export default {
  name: "AppShowEvent",
  props: {
    event: {
      type: Object,
      required: true
    },
    eventPage: {
      type: String,
      default: "EventProfilePage"
    },
    additionalParams: {
      type: Object,
      default: () => ({})
    }
  },
  fragments: {
    event: gql`
      fragment _ on Event {
        id
        name
        status
        organiser {
          id
          name
        }
        hostOrganisation {
          id
          name
        }
      }
    `
  }
};
</script>
